var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_233",
    "data-name": "Gruppe 233",
    transform: "translate(-1195.422 -2423.138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1",
    "data-name": "Rechteck 1",
    width: 33,
    height: 33,
    transform: "translate(1195.422 2423.138)",
    fill: "#007BC0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_475",
    "data-name": "Pfad 475",
    d: "M7.022,11.667,0,4.645,2.269,2.377,7.022,7.022,14.043,0l2.269,2.269Z",
    transform: "translate(1203.578 2433.617)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckmark);
export default __webpack_public_path__ + "static/media/blue-checkmark.b037d583581973a7392d7731df399c7a.svg";
export { ForwardRef as ReactComponent };